export default defineNuxtPlugin((nuxt) => {
    nuxt.hook("app:mounted", () => {
        const { $intercom } = useNuxtApp();

        if (!$intercom.appId) return;

        const { user } = useUser();

        if(user.value?.is_super_admin) return;

        function update(user: User | null) {
            const api_base = {
                app_id: $intercom.appId,
                alignment: "right",
                api_base: "https://api-iam.eu.intercom.io",
                hide_default_launcher: true,
            };

            if (user) {
                const userData = {
                    user_id: user.id,
                    name: user.name,
                    email: user.email,
                    avatar: user.avatar,
                    company: {
                        company_id: user.account.id,
                        name: user.account?.name,
                    },
                    created_at: Math.round(new Date().getTime() / 1000),
                    phone: user.phone,
                };

                if (!$intercom.visible) {
                    $intercom.boot(api_base);
                }

                $intercom.update(userData);
            } else {
                $intercom.boot(api_base);
            }
        }

        update(user.value);

        watch(user, update);
    });
});
